/**
 * Utility functions for checkout operations
 */

/**
 * Builds a checkout body object with optional booking email and marketing consent.
 * Only includes fields that have values to avoid sending empty objects.
 *
 * @param bookingEmailAddress - Optional email address for the booking
 * @param marketingConsent - Optional marketing consent flag
 * @returns An object with bookingEmailAddress and/or marketingConsent, or undefined if both are empty
 */
export function buildCheckoutBody(
  bookingEmailAddress?: string,
  marketingConsent?: boolean,
): { bookingEmailAddress?: string; marketingConsent?: boolean } | undefined {
  const body: {
    bookingEmailAddress?: string;
    marketingConsent?: boolean;
  } = {};

  if (bookingEmailAddress) {
    body.bookingEmailAddress = bookingEmailAddress;
  }

  if (marketingConsent) {
    body.marketingConsent = true;
  }

  // Return undefined if body is empty to avoid sending empty objects
  return Object.keys(body).length > 0 ? body : undefined;
}







